import { FormattedMessage } from 'react-intl';

export const userAvatarMessages = {
  'userAvatar.menu.account.label': (
    <FormattedMessage
      id="userAvatar.menu.account.label"
      defaultMessage="Account"
    />
  ),
  'userAvatar.menu.registry.label': (
    <FormattedMessage
      id="userAvatar.menu.registry.label"
      defaultMessage="Registry"
    />
  ),
  'userAvatar.menu.manageUsers.label': (
    <FormattedMessage
      id="userAvatar.menu.manageUsers.label"
      defaultMessage="Manage users"
    />
  ),
  'userAvatar.menu.admin.label': (
    <FormattedMessage id="userAvatar.menu.admin.label" defaultMessage="Admin" />
  ),
  'userAvatar.menu.solrSync.label': (
    <FormattedMessage
      id="userAvatar.menu.solrSync.label"
      defaultMessage="Solr sync"
    />
  ),
  'userAvatar.menu.societySetup.label': (
    <FormattedMessage
      id="userAvatar.menu.societySetup.label"
      defaultMessage="Society setup"
    />
  ),
  'userAvatar.menu.logout.label': (
    <FormattedMessage
      id="userAvatar.menu.logout.label"
      defaultMessage="Log out"
    />
  ),
};
